import { PBreadCrumb } from 'components/prime/PBreadCrumb/PBreadCrumb';
import { useObservableState } from 'observable-hooks';
import React from 'react';
import { getUserStore } from 'stores/user.store';
import { LeftPanelPageBreadCrumbsStyle as S } from './LeftPanelPageBreadCrumbs.style';

export const LeftPanelPageBreadCrumbs: React.FC = () => {
  const onboardingStatus = useObservableState(getUserStore().$onboardingStatus);
  return (
    <S.Container>
      <S.Divider layout="vertical" />
      <PBreadCrumb
        model={[
          {
            label: 'Sign up',
            className: !onboardingStatus || onboardingStatus === 'new' ? 'active' : '',
          },
          {
            label: 'Profile',
            className: onboardingStatus === 'email-verified' ? 'active' : '',
          },
          // {
          //   label: 'Details',
          //   className:
          //     onboardingStatus === 'profile-complete' && !window.location.pathname.includes('/get-started')
          //       ? 'active'
          //       : '',
          // },
        ]}
        homeHidden={true}
      />
    </S.Container>
  );
};
